import React from 'react';
import { VideoRequest } from '../types/video';
import HistoryPanel from './HistoryPanel';

interface HistoryDrawerProps {
  open: boolean;
  onClose: () => void;
  history: VideoRequest[];
  isLoading: boolean;
  onSelectVideo: (video: VideoRequest) => void;
}

const HistoryDrawer: React.FC<HistoryDrawerProps> = ({
  open,
  onClose,
  history,
  isLoading,
  onSelectVideo,
}) => {
  if (!open) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex">
      <div
        className="flex-1 bg-black/30 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />
      <aside
        className="relative h-full w-full max-w-md bg-[var(--color-surface)] shadow-xl border-l border-[var(--color-border)]"
        role="dialog"
        aria-label="Videogeschiedenis"
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-[var(--color-border)] bg-[var(--color-surface-alt)]">
          <div>
            <h2 className="text-lg font-semibold text-[var(--color-text-primary)]">Videogeschiedenis</h2>
            <p className="text-xs text-[var(--color-text-secondary)]">Recent gegenereerde scenario's</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-full border border-[var(--color-border)] bg-[var(--color-surface)] px-3 py-1 text-sm text-[var(--color-text-secondary)] hover:text-accent"
          >
            Sluiten
          </button>
        </div>
        <div className="h-[calc(100%-64px)] overflow-y-auto p-4">
          <HistoryPanel
            history={history}
            onSelectVideo={(video) => {
              onSelectVideo(video);
              onClose();
            }}
            isLoading={isLoading}
          />
        </div>
      </aside>
    </div>
  );
};

export default HistoryDrawer;
